'use client';

import { usePathname } from 'next/navigation';
import ResponsiveHeader from '@/components/layout/ResponsiveHeader';

export default function GlobalHeader() {
  const pathname = usePathname();

  const isBusinessManagerPage = pathname.startsWith('/store/') && pathname.includes('/manager');

  if (isBusinessManagerPage) return null; // 在這些頁面隱藏全站 header

  return <ResponsiveHeader mode="mediaQuery" />;
}
